import { compose, withHandlers, withProps } from 'recompose';
import { withRouter } from 'react-router';

import { t } from '../../../../../../modules/infra/i18n';
import AutoPayoutEligibilityStep from './AutoPayoutEligibilityStep';
import withNotifications from '../../../../../common/withNotifications';
import withPermissions from '../../../../../auth/utils/withPermissions';
import { canUserViewDashboard, canUserViewReports } from '../../../../../common/helpers/users';
import { AUTO_PAYOUT_ELIGIBILITY_CREDIT_TO_CASH_RATIO_URL } from '../../../../../common/KnowledgeArticleLink/constants';

export default compose(
  withRouter,
  withNotifications,
  withPermissions,
  withProps(props => ({
    name: t('settings:auto_payout.credit_to_cash_ratio'),
    description: t('settings:auto_payout.credit_cash_description'),
    knowledgeArticleUrl: AUTO_PAYOUT_ELIGIBILITY_CREDIT_TO_CASH_RATIO_URL,
    eligibilityActionDescription: t('settings:auto_payout.see_total_gross_sales'),
    hasPermissionsToViewTgsReport: canUserViewReports(props.permissions) && canUserViewDashboard(props.permissions),
  })),
  withHandlers(({
    onEligibilityActionClicked: props => () => {
      if (!props.hasPermissionsToViewTgsReport) {
        props.addNotification({
          title: t('common:error_title'),
          level: 'error',
          message: t('settings:auto_payout.no_permissions_error'),
        });

        return;
      }

      props.router.push('/reports/dashboard/v2');
    },
  })),
)(AutoPayoutEligibilityStep);
